import React from 'react';
import dayjs from 'dayjs';
import { StateInfo } from '../types';
import BroadcastStateIcon from './BroadcastStateIcon';
import { Card, Carousel, Space } from 'antd';
import Title from 'antd/es/typography/Title';
import { validBroadcastStateCodes } from '../BroadcastStateCodes';
import Paragraph from 'antd/es/typography/Paragraph';

type BroadcastStateDisplayProps = {
  stateInfo: StateInfo | undefined;
  broadcastTimeframe: { estStartTime: string; estEndTime: string };
};

function BroadcastStateDisplay({ stateInfo, broadcastTimeframe }: BroadcastStateDisplayProps) {
  return (
    <>
      <Card title={<Title level={3}>Staða útsendingar</Title>} style={{ width: 400 }}>
        <Space direction='vertical' style={{ width: 350 }}>
          <Space align='center'>
            <>
              <BroadcastStateIcon
                stateInfo={stateInfo}
                broadcastTimeframe={broadcastTimeframe}
                displayHelp={false}
                size='large'
              />
            </>
            {stateInfo ? (
              // The second case can come up if the time has come clientside but the
              // newest information from the backend has not been fetched yet.
              !validBroadcastStateCodes.includes(stateInfo.code) ? (
                <h3>Óþekkt</h3>
              ) : stateInfo.code === 'SCHEDULED' && dayjs().isAfter(dayjs(broadcastTimeframe.estStartTime)) ? (
                <h3>Verið er að opna fyrir útsendingu...</h3>
              ) : (
                <h3>{stateInfo.user_info_meaning}</h3>
              )
            ) : (
              <h3>Sæki upplýsingar...</h3>
            )}
          </Space>
          {stateInfo && (
            <Carousel autoplay speed={8000} fade dots={false}>
              {stateInfo.user_info_details?.map((detail: string, index: number) => (
                <div style={{ marginBottom: '-15px' }} key={index}>
                  <Paragraph>{detail}</Paragraph>
                </div>
              ))}
            </Carousel>
          )}
        </Space>
      </Card>
    </>
  );
}

export default BroadcastStateDisplay;
